import * as api from '../../../clients/veranstaltungen';

import {Action} from '@ngrx/store';

export const POST_AUFGABE_FEHLERBILD_HINZUFUEGEN = '[VeranstaltungenModul] PostAufgabeFehlerbildHinzufuegen laden';
export const POST_AUFGABE_FEHLERBILD_HINZUFUEGEN_AUSFUEHREN = '[VeranstaltungenModul] PostAufgabeFehlerbildHinzufuegen ausführen';
export const POST_AUFGABE_FEHLERBILD_HINZUFUEGEN_ERFOLGREICH = '[VeranstaltungenModul] PostAufgabeFehlerbildHinzufuegen laden erfolgreich';
export const POST_AUFGABE_FEHLERBILD_HINZUFUEGEN_FEHLER = '[VeranstaltungenModul] PostAufgabeFehlerbildHinzufuegen Ladefehler';
export const POST_AUFGABE_FEHLERBILD_HINZUFUEGEN_NICHT_AUSGEFUEHRT = '[VeranstaltungenModul] PostAufgabeFehlerbildHinzufuegen nicht ausgeführt (evtl. Offline)';


export class PostAufgabeFehlerbildHinzufuegenAction implements Action {
    readonly type = POST_AUFGABE_FEHLERBILD_HINZUFUEGEN;
        constructor(public aufgabeBildRequest: api.AufgabeBildRequest, public optPayload: any = null) {}
    }
export class PostAufgabeFehlerbildHinzufuegenAusfuehrenAction implements Action {
    readonly type = POST_AUFGABE_FEHLERBILD_HINZUFUEGEN_AUSFUEHREN;
        constructor(public aufgabeBildRequest: api.AufgabeBildRequest, public optPayload: any = null) {}
    }
export class PostAufgabeFehlerbildHinzufuegenErfolgreichAction implements Action {
    readonly type = POST_AUFGABE_FEHLERBILD_HINZUFUEGEN_ERFOLGREICH;
        constructor(public payload: api.AufgabeIdentifier, public aufgabeBildRequest: api.AufgabeBildRequest, public optPayload: any = null) {}
    }
export class PostAufgabeFehlerbildHinzufuegenFehlerAction implements Action {
    readonly type = POST_AUFGABE_FEHLERBILD_HINZUFUEGEN_FEHLER;
        constructor(public payload: any, public aufgabeBildRequest: api.AufgabeBildRequest, public optPayload: any = null) {}
    }
export class PostAufgabeFehlerbildHinzufuegenNichtAusgefuehrtAction implements Action {
    readonly type = POST_AUFGABE_FEHLERBILD_HINZUFUEGEN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type VeranstaltungenCommandAufgabeFehlerbildHinzufuegenActions =
    PostAufgabeFehlerbildHinzufuegenAction
    | PostAufgabeFehlerbildHinzufuegenAusfuehrenAction
    | PostAufgabeFehlerbildHinzufuegenErfolgreichAction
    | PostAufgabeFehlerbildHinzufuegenFehlerAction
    | PostAufgabeFehlerbildHinzufuegenNichtAusgefuehrtAction
    ;
